export enum EditorType {
  CampaignPage = 'campaign_page',
  CategoryPage = 'category_page',
  CollectionPage = 'collection_page',
  ThemeCollectionPage = 'theme_collection_page',
}
